import { signOut } from "next-auth/react";
import { toast } from "react-toastify";

// Track error status to prevent duplicates
let isHandlingAuthError = false;
let currentMigrationError = null;

const useErrorHandling = () => {
  const handleError = async (err, showError = true, showAllError = false) => {
    let error = null;

    if (isAxiosError(err)) {
      const apiError = err.response?.data;
      if (err.response) {
        if (err.response.status === 401) {
          // Handle auth errors
          if (!isHandlingAuthError) {
            isHandlingAuthError = true;
            toast.error("Unauthenticated", {
              position: "top-right",
              onClose: () => {
                isHandlingAuthError = false;
              },
            });
            showError = false;
            await signOut({ callbackUrl: "/login" });
          } else {
            showError = false;
          }
        } else if (err.response.status === 403) {
          showError = false;
        } else if (err.response.status === 404) {
          showError = false;
        }
        error = apiError?.message || "An error occurred";

        // Handle database migration errors
        if (
          error.includes("Base table or view not found") ||
          (error.includes("Table") && error.includes("doesn't exist"))
        ) {
          // Check if we're already showing this specific migration error
          if (currentMigrationError !== error) {
            currentMigrationError = error;
            toast.error("Database not connected.", {
              position: "top-right",
              onClose: () => {
                currentMigrationError = null;
              },
            });
          }
          showError = false;
        }
      } else {
        error = err.message;
      }
    } else {
      error = "An unexpected error occurred";
    }

    if (showError && !showAllError) {
      toast.error(error, {
        position: "bottom-left",
      });
    }
    return error;
  };

  return [handleError];
};

function isAxiosError(err) {
  return err.isAxiosError !== undefined;
}

export default useErrorHandling;
